import React, { useRef, useState } from 'react';
import classNames from 'classnames';

import { DropdownOption, MultiDropdownProps } from '@/components/dropdown/types';

const MultiDropdown = ({
	color,
	expanded = false,
	selectedValue,
	toggleDropdown,
	hideExpandedIcon,
	label,
	dataNameAttribute,
	optionTitleKey = 'title',
	handleItem,
}: MultiDropdownProps) => {
	const [mouseDown, setMouseDown] = useState(false);
	const formRef = useRef<HTMLDivElement | null>(null);

	const onMouseDown = () => {
		setMouseDown(true);
	};

	const onMouseUp = () => {
		setMouseDown(false);
	};

	const onFocus = () => {
		if (!mouseDown) {
			toggleDropdown();
		}
	};

	const handleRemoveItem = (e: React.MouseEvent, item: DropdownOption) => {
		e.stopPropagation();
		handleItem(item, null, true);
	};

	return (
		<div
			ref={formRef}
			className={classNames('dropdown-form multi', {
				'light-gray': color === 'gray',
			})}
			data-name={dataNameAttribute}
			onClick={toggleDropdown}
			onFocus={onFocus}
			onMouseUp={onMouseUp}
			onMouseDown={onMouseDown}
			tabIndex={0}
		>
			{selectedValue.length ? (
				selectedValue.map((item) => (
					<div className="multi-item" key={item[optionTitleKey] as string}>
						<span className="title">{item[optionTitleKey] as string}</span>
						<button
							type="button"
							className="remove-btn"
							onClick={(e) => handleRemoveItem(e, item)}
						>
							<span className="icon icon-close" />
						</button>
					</div>
				))
			) : (
				<span className="label">{label}</span>
			)}
			<span
				className={classNames(
					'icon',
					{ 'icon-chevron-up': !hideExpandedIcon },
					'right-icon',
					{ expanded },
				)}
			/>
		</div>
	);
};

export default MultiDropdown;
